import { render } from "./option.vue?vue&type=template&id=5b72e496&scoped=true&ts=true"
import script from "./option.vue?vue&type=script&lang=ts"
export * from "./option.vue?vue&type=script&lang=ts"

import "./option.vue?vue&type=style&index=0&id=5b72e496&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b72e496"]])

export default __exports__